export default __webpack_public_path__ + "static/media/Sign-out.62b663f5.svg";